export default __webpack_public_path__ + "static/media/maintenance.59210420.svg";